import { HighlightMatch } from '../types';

export enum ExplainabilityBadge {
	Metadata = 'metadata',
	Description = 'description',
	Transcript = 'transcript',
	TextInDocument = 'textInDocument',
	TextInImage = 'textInImage',
	VisualMatch = 'visualMatch',
	LexicalMatch = 'lexicalMatch',
}

export const EXPLAINABILITY_BADGE_LABEL_KEYS: Record<ExplainabilityBadge, string> = {
	[ExplainabilityBadge.Metadata]: 'spotlight.explainabilityBadge.metadata',
	[ExplainabilityBadge.Description]: 'spotlight.explainabilityBadge.description',
	[ExplainabilityBadge.Transcript]: 'spotlight.transcript',
	[ExplainabilityBadge.TextInDocument]: 'spotlight.explainabilityBadge.textInDocument',
	[ExplainabilityBadge.TextInImage]: 'spotlight.textInImage',
	[ExplainabilityBadge.VisualMatch]: 'spotlight.explainabilityBadge.visualMatch',
	[ExplainabilityBadge.LexicalMatch]: 'spotlight.explainabilityBadge.lexicalMatch',
};

const hasMatch = (snippets?: string[]) => !!snippets?.length;

export const deriveExplainabilityBadge = (
	highlight?: HighlightMatch,
): ExplainabilityBadge | null => {
	if (!highlight?.badges) {
		return null;
	}

	// Tags and copyright are separate highlight fields but one badge: the row says the match was
	// somewhere in the asset's metadata, not which field it was.
	if (hasMatch(highlight.tags) || hasMatch(highlight.copyright)) {
		return ExplainabilityBadge.Metadata;
	}

	if (hasMatch(highlight.description)) {
		return ExplainabilityBadge.Description;
	}

	if (hasMatch(highlight.transcription)) {
		return ExplainabilityBadge.Transcript;
	}

	if (hasMatch(highlight.fileContent)) {
		return ExplainabilityBadge.TextInDocument;
	}

	if (hasMatch(highlight.textFromImage)) {
		return ExplainabilityBadge.TextInImage;
	}

	if (highlight.badges.includes('visual')) {
		return ExplainabilityBadge.VisualMatch;
	}

	if (highlight.badges.includes('lexical')) {
		return ExplainabilityBadge.LexicalMatch;
	}

	return null;
};
